/* eslint-disable react-hooks/exhaustive-deps */
import { InlineLoader, ModalNextContext, useModal, DateField } from '@jutro/components';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { withRouter } from 'react-router-dom';
import { ClaimService } from 'gw-capability-claim';
import { GatewayClaimService } from 'gw-capability-gateway-claim';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { PolicyService } from 'gw-capability-policy';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import {
    getNormalizedLOBName,
    isCapabilityEnabled,
} from '@xengage/gw-portals-config-js';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import { LoaderExt } from 'gw-components-platform-react';
import { useCallback, useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import messages from '../../Claims.messages';
import styles from './ClaimList.module.scss';
import metadata from './ClaimList.metadata.json5';
import ClaimListComponent from '../../components/ClaimListComponent/ClaimListComponent';
import { AsyncLink } from '../../../../../../../platform/@jutro/uiconfig/node_modules/@jutro/router';
import usecpmiAnalytics from '../../../../hooks/usecpmiAnalytics'
import useGoogleAnalytics from '../../../../hooks/useGoogleAnalytics';
import CEsubscriptionLossRunModal from "./CEsubscriptionLossRunModal"
import { AccountDropDownValues } from '../../../cpmi_SelectAccountDropDown';


import { Button } from '@jutro/legacy/components';


const { capabilitiesConfig } = appConfig;

function ClaimList(props) {
    const { history } = props;
    const ModalNext=useContext(ModalNextContext);
    const auth = useAuthentication();
    const { authHeader } = useAuthentication();
    // const authHeader = useAuthentication();
    const translator = useTranslator();
    const [accountPolicyData, setAccountPolicyData] = useState([]);
    const [accountBillingData, setAccountBillingData] = useState([]);
    const [accountData, setAccountData] = useState([]);
    const [isLoading, setLoadingState] = useState(true);
    const [isInlineLoading, setInlineLoadingState] = useState(false);
    const [policyNumber, setPolicyNumber] = useState('');
    const [trackPageView, trackEvent] = usecpmiAnalytics();
    const [ trackGAPageView] = useGoogleAnalytics();
    const[requestAllClaimStatus,setAllClaimStatus]=useState(false);
    const[requestClosedClaimStatus,setClosedClaimStatus]=useState(false);
    const[requestOpenClaimStatus,setOpenClaimStatus]=useState(false);
    const[requestClaimHistory,setRequestClaimHistory]=useState(false);
    const[requestLossRun,setRequestLossRun]=useState(false);
    const[userDataInfo,setUserData]=useState(false);
    const[showLossRun,setlossRun]=useState(false);
    const[isLossRunDownloading,setIsLossRunDownloading]=useState(false);
    const [claimAccountDropdown,setClaimAccountDropdown]=useState();
    const [ClaimsPromise,setClaimsPromise]=useState([])
    const [accountClaimsData,setAccountclaimsPromise]=useState([])
    
    const {
        showModal,
    } = useModal();



    function renderLoader(isInlineLoading) {
        return isInlineLoading ? <InlineLoader loading={isInlineLoading} className="gw-inline-loader" /> : null;
    }


    const functionClaimList = async()=>{
        setLoadingState(true);
        let policyPromise;
        policyPromise = await PolicyService.getAllAvailableAccountPolicySummaries_Ext(
            authHeader
        )
            .then(async(res) => {
              
               
                setAccountPolicyData(res);
                const policyData=res;
                let showFlag=0;

                if(res.length>0)
                {
                    for (let i = 0; i < policyData.length; i++) {
                   
                        if (policyData[i].displayStatus === "In Force" || policyData[i].displayStatus === "Scheduled") {
                            
                            if (policyData[i].producerDescription.indexOf("CopperPoint") !== -1) {
                                showFlag++;
                                
                                break;
                            }
                        }
                    }
                    
                    if(showFlag===0)
                    {
                        setlossRun(true)
                    }
                    else{
                        setlossRun(false)
                    }
                    
                    let allClaim = [
                        {
                            accountNumber: res[0].accountNumber,
                            policyNumber: res[0].policyNumber,
                            reportType: 'ClaimStatusReport',
                            claimStatus: 'all',
                            emailID: auth.userInfo.email,
                        },
                       
                    ];
                    GatewayClaimService.reportStatus(allClaim,authHeader).then((res) =>{
                        setAllClaimStatus(res);
                       
                    });
                    const openclaim = [
                        {
                            accountNumber: res[0].accountNumber,
                            policyNumber: res[0].policyNumber,
                            reportType: 'ClaimStatusReport',
                            claimStatus: 'open',
                            emailID: auth.userInfo.email,
                        },
                    ];
                    GatewayClaimService.reportStatus(openclaim,authHeader).then((res)=>{
                        setOpenClaimStatus(res);
    
                    })
                    const closedClaims = [
                        {
                            accountNumber: res[0].accountNumber,
                            policyNumber: res[0].policyNumber,
                            reportType: 'ClaimStatusReport',
                            claimStatus: 'Closed',
                            emailID: auth.userInfo.email,
                        },
                    ];
                    GatewayClaimService.reportStatus(closedClaims,authHeader).then((res)=>{
                        setClosedClaimStatus(res);
                    })
                    const lossHistory = [
                        {
                            accountNumber: res[0].accountNumber,
                            policyNumber: res[0].policyNumber,
                            reportType: 'CELoss',
                            emailID: auth.userInfo.email,
                        },
                    ];
                    GatewayClaimService.reportStatus(lossHistory,authHeader).then((res)=>{
                        setRequestClaimHistory(res);
                    })
                    const lossRun = [
                        {
                            accountNumber: res[0].accountNumber,
                            policyNumber: res[0].policyNumber,
                            reportType: 'PLoss',
                            emailID: auth.userInfo.email,
                        },
                    ];
                    GatewayClaimService.reportStatus(lossHistory,authHeader).then((res)=>{
                        setRequestLossRun(res);
                    })
                }

            })
            .finally(() => {
            setLoadingState(false);
            });
    }

    useEffect( () => {
        functionClaimList();
    }, []);

    useEffect(() => {
        trackPageView("Claim List", "/claims");
    },[])

    useEffect(() => {
        trackGAPageView("/claims", "Claims")
    },[])

    const renderClaimsHistory = useCallback(() => {
        const reportLossHistoryDto = [
            {
                accountNumber: accountPolicyData[0].accountNumber,
                policyNumber: accountPolicyData[0].policyNumber,
                reportType: 'CELoss',
                emailID: auth.userInfo.email,
            },
        ];
        ModalNext.showConfirm({
            title: messages.claimHistoryTitle,
            message: translator(messages.claimHistoryMessage, {
                email: auth.userInfo.email,
            }),
            confirmButtonText: messages.claimHistoryConfirm,
            cancelButtonText: messages.claimHistoryCancel,
        }).then((results) => {
            if (results === 'confirm') {
                try {
                    setRequestClaimHistory(false);
                    const claimsHistoryReport =  GatewayClaimService.requestReport(
                        reportLossHistoryDto,
                        authHeader
                    ).then((res) =>{
                        
                        setRequestClaimHistory(false);
                    });
                   
                } catch (documentDeletionError) {
                    ModalNext.showAlert({
                        title: messages.documentDeletionFailed,
                        message: messages.documentCannotDeleted,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: 'OK',
                    }).catch(_.noop);
                }
                return true;
            }
        }, _.noop);
    }, [accountPolicyData, ModalNext, translator, auth.userInfo.email]);

   
    const modalPopUp = () => {

        const results = showModal(
            // eslint-disable-next-line react/react-in-jsx-scope
            <CEsubscriptionLossRunModal props={props}
                userDataInfo={userDataInfo}
                content={isLossRunDownloading ? renderLoader(isInlineLoading) : 'Download Loss Run'}
                accountPolicyData={accountPolicyData[0]}
                accountNumber={claimAccountDropdown}
                policyNumber={accountPolicyData[0].policyNumber}
                email={auth.userInfo.email}
                authHeader={authHeader}

            />
        );

        return results;
    
    }

    const callLossRunDownloadClaimsReports=()=>{
        modalPopUp()
    }
    

    const functionClaimListData = async()=>{
        // setLoadingState(true); 
        const query = {
            claimStates: ['open','draft','closed']
        };
        //const claimsPromise = await ClaimService.getClaimSummaries(query, {}, "", authHeader);
        const userInfo= await EnrollmentService.getUser(auth.userInfo.email,authHeader);
         
        if(userInfo.canViewClaimReport)
        {
            setUserData(true)
        }
        else{
            // return false
            setUserData(false);
        }
    }

    useEffect(()=>{
        functionClaimListData();
    },[])


    useEffect(() => {
        const tempClaimFileredData = []

        if (claimAccountDropdown !== undefined && !_.isEmpty(ClaimsPromise)) {
            ClaimsPromise.items.map((data) => {
                if (data.accountNumber === claimAccountDropdown) {
                    tempClaimFileredData.push(data)
                }
            })
            setAccountclaimsPromise(tempClaimFileredData)
        }

    }, [claimAccountDropdown, ClaimsPromise])

    useEffect(() => {
        const { history } = props
        history.push({

            pathname: '',

            state: {

                claimListComponentData: claimAccountDropdown

            },
        });

    }, [accountClaimsData])

    const handleFileWCClick = useCallback(() => {
        return history.push({
            pathname: '/fnol-select-policy',
            state: {
                redirectPath: '/claims',
                page: 'ClaimsPage'

            }
        });
    }, [history]);

    const handleFileNonWCClick = useCallback(() => {
        return window.open('https://www.copperpoint.com/insurance-claims/package-auto-umbrella', '_blank');
    }, []);

    const handleValueChange=(value)=>{ 
        setClaimAccountDropdown(value)   
    }
  
    if (isLoading) {
        // eslint-disable-next-line react/react-in-jsx-scope
        return <LoaderExt loaded={!isLoading} />;
    }
    const overrides = {
        downloadLossRunCE: {
            // content: isLossRunDownloading ? 'Please wait...' : 'Download Loss Run'
            content:isLossRunDownloading ? renderLoader(isInlineLoading) : 'Download Loss Run'
        },
        claimLossRun:{
            disabled:!requestLossRun,
            visible:showLossRun
        },
        claimStatusContainer:{
            visible:true//userDataInfo
        },
        claimList:{
            callLossRunDownloadClaimsReports,
            setClaimsPromise : setClaimsPromise
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            claimlistcomponent: ClaimListComponent,
            AccountDropDownValues: AccountDropDownValues,
        },
        resolveCallbackMap: {
            renderClaimsHistory: renderClaimsHistory,
            callLossRunDownloadClaimsReports: callLossRunDownloadClaimsReports,
            modalPopUp: modalPopUp,
            handleValueChange,
            handleFileWCClick: handleFileWCClick,
            handleFileNonWCClick: handleFileNonWCClick
        },
    };

    // eslint-disable-next-line react/react-in-jsx-scope
    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
}

export default withRouter(ClaimList);